import React from 'react';
import { FormMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useSeniorityFilter } from './useSeniorityFilter';

export const SeniorityFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit, seniorityOptions } = useSeniorityFilter({
    setFilters,
  });

  return (
    <Formik
      initialValues={{ seniorities: value || [] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="seniorities"
          label="Seniority"
          placeholder="Select"
          size="small"
          component={FormMultiSelect}
          options={seniorityOptions}
          isSearchable={false}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

SeniorityFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
};

SeniorityFilter.defaultProps = {
  value: [],
};
